import styled, { css } from 'styled-components'

export const Container = styled.div`
  padding: 2.5rem 2.2rem;
`
export const WrapperTitle = styled.div`
  margin: 0rem 0rem 1.2rem 0rem;
  top: 0;
  z-index: 1001;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  padding: 1rem 0;
  gap: 1rem;
`
export const BetesaTitle = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #000;
  margin-bottom: 0;
`

export const CompanySubtitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin: 0;
`

export const BetesaCount = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #000;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`
export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`
export const TabContainer = styled.div`
  display: flex;
  margin-bottom: 40px;
`

export const Tab = styled.button<{ active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #ccc;
  background-color: ${(props) => (props.active ? '#fff' : '#f1f1f1')};
  ${(props) =>
    props.active &&
    css`
      border-bottom: 1px solid #fff;
    `}
`

export const SearchContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 50%;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`
